import { HttpParams } from '@angular/common/http';
import { ApiRequest } from './';

export class UserStreamsRequestModel implements ApiRequest {
    constructor(public userId: string,
                public page: number = 0,
                public rows: number = 400,
                public includeFullDescription: boolean = true,
                public term: string = undefined,
                public sort: string = undefined,
                public sortDirection: string = undefined){}

    safeSet = (params, key, item) => item ? params.set(key, String(item)) : params;

    asURLSearchParams() {
        let params = new HttpParams();

        params = this.safeSet(params, 'targetUserId', this.userId);
        params = this.safeSet(params, 'page', this.page);
        params = this.safeSet(params, 'rows', this.rows);
        params = this.safeSet(params, 'term', this.term);
        params = this.safeSet(params, 'sort', this.sort);
        params = this.safeSet(params, 'sortDirection', this.sortDirection);
        params = this.safeSet(params, 'includeFullDescription', this.includeFullDescription);

        return params;
    }
}
